module.exports = __webpack_public_path__ + "static/media/iphone_15.ebaea107.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/custom-products/iphone/iphone_15.png
// module id = 2139
// module chunks = 0